import React, { useContext, useEffect } from 'react'
import { Helmet } from 'react-helmet'

import Header from './Header';
import './css/notes.css'
import Permission from '../Permission';
import { AppContext } from '../../Context';
import { permissions } from '../../inc/Fetch';
import { useParams } from 'react-router-dom';

export default function Smoosic() {

    const params = useParams();
    const { successData, userData, siteData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;
    const [data, setdata] = siteData;
    
    let site = data?.cats?.filter(r => r?.name == params?.id);
    site = site?.length ? site[0] : {};
    console.log(site?._id); 
    
    if (!userinfo?._id) {
            return <Permission />
    } else {
        
        let perms = permissions(userinfo, false, site?._id, "board");
        if (!perms) {
            return <Permission />
        }
        
    }

    return (
        <div className='mainAllMusicNotes'>

            <Header />

            <iframe src={'/notes.html'}></iframe>
        </div>


    )
}
